export default __webpack_public_path__ + "static/media/Die_1.abf59c49.png";